__webpack_require__.p = "https://demo.compliance.boolanga.com/";